module.exports = __webpack_public_path__ + "static/media/RP-58.05bdbe58.pdf";